import { render, staticRenderFns } from "./Confirm_promotion_internet.vue?vue&type=template&id=223a7b50&"
import script from "./Confirm_promotion_internet.vue?vue&type=script&lang=js&"
export * from "./Confirm_promotion_internet.vue?vue&type=script&lang=js&"
import style0 from "./Confirm_promotion_internet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports